import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    defaultPageSize,
    pageSizeOptions,
    showSizeChanger,
    AsumsiIcon,
    IColumnProps, Table, Tooltip, Confirm, Toggle
} from 'asumsi-components';
import { IResponseMasterUser } from '@interfaces/iresponse-user';

export default function (props: any) {
    const { dataSource, metaData, onTableChange, loading, updateStatus, fetchDataList } = props;
    const [showConfirmation, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(false);

    const showConfirm = async (e: any) => {
        e.preventDefault();
        setDeleteId(e.target.id);
        setShowConfirm(true);
    };

    const onChangeStatus = async (active: boolean, id: string) => {
        await updateStatus({ active }, id);
        fetchDataList();
    }

    const columns: IColumnProps[] = [
        {
            dataIndex: 'name',
            key: 'name',
            title: 'Name',
            sorter: true,
            render: (text: any, record: IResponseMasterUser) => `${record.firstName} ${record.lastName ?? ""}`
        },
        {
            dataIndex: 'email',
            key: 'email',
            title: 'Email',
            sorter: true,
        },
        {
            dataIndex: 'roleGroup',
            key: 'roleGroup',
            title: 'Created Date',
            columnWidht: "10%",
            render: (text: any) => text ? text.name : null
        },
        {
            dataIndex: 'active',
            key: 'active',
            title: 'Status',
            columnWidht: "8%",
            render: (text: string, record: any) => <Toggle defaultChecked={record.active == true} onChange={(e: any) => onChangeStatus(e.target.checked, record.userId)}></Toggle>
        },
        {
            dataIndex: 'action',
            key: 'action',
            render: (text: string, record: any) => {
                return (
                    <div className="bt-table__action">
                        <Tooltip text="edit">
                            <Link to={`/user/users/form/${record.userId}`} style={{ marginRight: "8px" }}>
                                <AsumsiIcon icon="annotation" />
                            </Link>
                        </Tooltip>
                        <Tooltip text="hapus">
                            <Link to="" style={{ marginRight: "5px" }}>
                                <AsumsiIcon id={record.userId} onClick={showConfirm} icon="trash" />
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
            columnWidht: "8%",
            title: 'Action',
        },
    ];

    return (
        <Fragment>
            <Table columns={columns}
                dataSource={dataSource}
                className="asumsi-table"
                loading={loading}
                pagination={{
                    currentPage: metaData ? metaData.page : 1,
                    defaultPageSize: metaData ? metaData.limit : defaultPageSize,
                    pageSizeOptions,
                    showSizeChanger,
                    total: metaData ? metaData.totalRecords : 0,
                }}
                rowKey="id"
                onChange={onTableChange}
                upperCaseTitle={true}
            ></Table>
            <Confirm
                loading={loading}
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    await props.deleteData(deleteId);
                    props.fetchDataList();
                }}
                content='Are you sure you want to delete this item?'
                title='Konfirmasi'
                okText='Delete'
            />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/users/libraries/table.tsx